// removed by extract-text-webpack-plugin
module.exports = {"blank":"blank___uDbzd","controls":"controls___1Qv87","label":"label___2lQ-X","actions":"actions___2RvaE","employee":"employee___gy3Jd","employeeInfo":"employeeInfo___tmnBd","avatar":"avatar___3YGfw","name":"name___BQGPS","checkbox":"checkbox___13j9p","selected":"selected___1xa5a","links":"links___2XcPc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/EmployeeSelector/index.scss
// module id = 80
// module chunks = 0